<template>
    <div class="mycheck">
        <input type="checkbox" :disabled='true' :checked="checked" @change="checkChange($event)" :value="checkValue">
        <span>{{name}}</span>
    </div>
</template>
<script>
export default {
    name:'mecheck',
    props:{
        name:{type:String},
        checkValue:{
         type: [Number, String]    
        },
        checked: {      
         type: Number,       
         default: 0   
        },    
    },
    methods:{
        checkChange(e) {      
             
        if (e.target.checked) {          
          this.$emit('change', e.target.value);        
        } else {          
          this.$emit('change', '');        
        }      
      }   
    }  

     

    }
        
    

        
    

</script>
<style lang="scss" scoped>
.mycheck{
    display: inline-block;
    align-items: center;
    margin-right: 10px;
    // input{
    //     width: 14px;
    //     height: 14px;
    //     border: 1px solid #DCDFE6;
    //     box-sizing: border-box;
    // }
          input[type="checkbox"]::after {
            // cursor: not-allowed;

          width: 14px;
          height: 14px;
          content: " ";
          color: #999;
          display: inline-block;
          visibility: visible;
          border-radius: 2px;
        //   padding: 1px 2px;
          box-sizing: border-box;
          background-color: #edf2fc;
          border: 1px solid #DCDFE6;;
          
      }
      input[type="checkbox"]:checked::after{
          content:"√";
          cursor: pointer;
          color: #333;
          font-size: 10px;
          font-weight: bolder;
          background-color: #edf2fc;
            line-height: 16px;
            text-align: center;
      }
    span{
        padding-left: 5px;
        line-height: 19px;
        font-size: 14px;
        color: #C0C4CC;
    }
}
</style>